import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import DropdownList from '../common/DropdownList';
import InfoTooltip from '../common/InfoTooltip';
import AddFeedback from './AddFeedback';
import { formatCurrency } from '../../numberUtils';
function LineItems(_ref) {
  var category = _ref.category,
    lineItemsGroupName = _ref.lineItemsGroupName,
    descriptionLabel = _ref.descriptionLabel,
    hasDuration = _ref.hasDuration,
    lineItems = _ref.lineItems,
    totalPay = _ref.totalPay,
    totalTime = _ref.totalTime,
    updateLineItemFeedback = _ref.updateLineItemFeedback,
    isValid = _ref.isValid,
    viewerIsEmployer = _ref.viewerIsEmployer;
  return /*#__PURE__*/React.createElement("div", {
    className: "line-items card p-5 border-0 ".concat(isValid ? '' : 'not-valid')
  }, /*#__PURE__*/React.createElement("div", {
    className: "request-edits-line-items body-text-2"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-edit"
  }), "Request line-by-line edits here:"), /*#__PURE__*/React.createElement("div", {
    className: "card-body px-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(category, "-line-items")
  }, /*#__PURE__*/React.createElement(DropdownList, {
    title: lineItemsGroupName,
    dropdownClass: hasDuration ? "".concat(category, "-hours") : "".concat(category, "s"),
    isSideBySide: true,
    icon: "caret"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header g-row--always"
  }, /*#__PURE__*/React.createElement("div", {
    className: "date"
  }, "Date"), /*#__PURE__*/React.createElement("div", {
    className: "optional-id"
  }, "Optional ID", /*#__PURE__*/React.createElement(InfoTooltip, {
    triggerClassName: "optional-id-tooltip-trigger",
    tooltipId: "optional-id-tooltip",
    tooltipPlacement: "top",
    tooltipText: "This is an optional field you and your consultant can use to capture project codes/ids, cost centers, or other helpful information."
  })), /*#__PURE__*/React.createElement("div", {
    className: "description"
  }, descriptionLabel), hasDuration && /*#__PURE__*/React.createElement("div", {
    className: "hours-and-minutes"
  }, "Hours"), /*#__PURE__*/React.createElement("div", {
    className: "total"
  }, "Total"), !hasDuration && /*#__PURE__*/React.createElement("div", {
    className: "file"
  }), /*#__PURE__*/React.createElement("div", {
    className: "actions"
  })), /*#__PURE__*/React.createElement("div", null, lineItems && lineItems.map(function (lineItem, index) {
    return /*#__PURE__*/React.createElement(AddFeedback, _extends({}, lineItem, {
      total: viewerIsEmployer ? lineItem.gross_total : lineItem.total,
      index: index,
      key: lineItem.id,
      hasDuration: hasDuration,
      updateLineItemFeedback: updateLineItemFeedback
    }));
  })), /*#__PURE__*/React.createElement("div", {
    className: "totals g-row--always"
  }, /*#__PURE__*/React.createElement("div", {
    className: "spacer1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "line-item-category-total"
  }, "Total", hasDuration ? category : "".concat(category, "s")), hasDuration && /*#__PURE__*/React.createElement("div", {
    className: "line-item-time"
  }, totalTime.hours, ' ', "h.", totalTime.minutes, ' ', "min."), /*#__PURE__*/React.createElement("div", {
    className: "line-item-total"
  }, formatCurrency(totalPay)), !hasDuration && /*#__PURE__*/React.createElement("div", {
    className: "spacer2"
  }))))));
}
LineItems.propTypes = {
  totalTime: PropTypes.shape({
    hours: PropTypes.number,
    mintues: PropTypes.number
  }),
  totalPay: PropTypes.number,
  lineItems: PropTypes.shape([]).isRequired,
  lineItemsGroupName: PropTypes.string.isRequired,
  descriptionLabel: PropTypes.string.isRequired,
  hasDuration: PropTypes.bool,
  category: PropTypes.string.isRequired,
  updateLineItemFeedback: PropTypes.func,
  isValid: PropTypes.bool.isRequired,
  viewerIsEmployer: PropTypes.bool.isRequired
};
LineItems.defaultProps = {
  totalPay: 0,
  totalTime: {
    hours: 0,
    minutes: 0
  },
  hasDuration: false,
  updateLineItemFeedback: function updateLineItemFeedback() {
    return null;
  }
};
export default LineItems;